import React from "react";
import * as S from './ButtonMmtStyles'
import { HOB_RIGHT_ARROW } from "../../../../../config/constants";

const ButtonMmt = ({
    onClick = () => {},
    type = 1,
    btnTxt = '',
    disabled = false,
    showIcon = false,
    number = '',
    isCall = false,
}) => {
  const handleCall = () => {
    if (typeof window !== "undefined") {
      window.location.href = `tel:${number}`;
    }
  };

  return (
    <S.Button
      onClick={() => {
        if (isCall) {
          onClick();
          handleCall();
        }
        else {
          onClick();
        }
      }}
      disabled={disabled}
      className={`type${type}`}
    >   
      {btnTxt}
      {
        showIcon &&
        <S.ArrowIcon
          src={HOB_RIGHT_ARROW}
          alt="arrow"
        />
      }
    </S.Button>
  );
};

export default ButtonMmt;